<template>
  <sub-page :title="title">
    <div class="result-page">
      <div class="empty-wrap">
        <img :src="emptyIcon" class="empty-icon" alt="暂无数据" />
        <div class="empty-text">{{ emptyText }}</div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'RightsRecordResult',
  components: { SubPage },
  data() {
    return {
      title: '个人权益记录查询打印',
      emptyIcon: require('@/assets/icons/empty-record.png')
    }
  },
  computed: {
    recordType() {
      return this.$route.query.type || ''
    },
    emptyText() {
      if (this.recordType.indexOf('城乡居民') > -1) {
        return '该人员没有支付信息，请确认！'
      }
      if (this.recordType.indexOf('病残津贴') > -1) {
        return '该人员没有待遇信息，请确认！'
      }
      if (this.recordType.indexOf('职业年金') > -1 || this.recordType.indexOf('机关事业') > -1) {
        return '未获取到该人员在机关事业的人员信息'
      }
      return '未查询到养老金打印信息'
    }
  }
}
</script>

<style scoped>
.result-page {
  background: #f8f8f8;
  min-height: 100%;
  /* page-body 为flex纵向容器，需 flex:1 才能撑满，保证背景铺满整屏底部 */
  flex: 1;
}
.empty-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: calc(300 * var(--w)) calc(60 * var(--w)) 0;
}
.empty-icon {
  width: calc(460 * var(--w));
  object-fit: contain;
}
.empty-text {
  margin-top: calc(100 * var(--w));
  font-size: calc(34 * var(--w));
  color: #323233;
  text-align: center;
  line-height: 1.6;
}
</style>




// WEBPACK FOOTER //
// src/pages/RightsRecordResult.vue